import { MeRepository, UsersRepository } from 'common/repositories/index';
import eventManager from 'common/services/-RFC.eventManager';

/**
 * Listen events for User Model
 */
angular.module('listeners')
    .service('UserListener', ($rootScope, $modal, $window) => {

        eventManager.subscribe('socket:users', (response) => {

            let userId;
            if (response.verb === 'POST') {

                UsersRepository.add(response.payload.data);

            }

            if (response.verb === 'PUT') {

                userId = MeRepository.getMyId();

                /* replace MeRepository with the response data if the
                userId from response is the current logged user */
                if (userId === response.payload.data.id) {

                    MeRepository.update(response.payload.data);

                }

                UsersRepository.update(response.payload.data);

            }

        });

        // Detect user's internet connection status (online/offline)
        $rootScope.online = navigator.onLine;

        $window.addEventListener('offline', () => {

            $rootScope.$apply(() => {

                $rootScope.online = false;

                // Trigger offline modal when the user don't have internet connection
                $modal.open({
                    template: require('../../..//views/modals/session-expired.html'),
                    controller: 'SessionExpire',
                    backdrop: 'static',
                    keyboard: false,
                    windowClass: 'white-modal error-modal',
                    resolve: {
                        modalParams() {

                            return 'offline';

                        },
                    },
                });

            });

        }, false);

        $window.addEventListener('online', () => {

            $rootScope.$apply(() => {

                $rootScope.online = true;
                eventManager.broadcast('connection:online');

            });

        }, false);

    });



// WEBPACK FOOTER //
// ./scripts/common/listeners/user.js